// extracted by mini-css-extract-plugin
export var name = "services-module--name--4QnBB";
export var inactive = "services-module--inactive--Ddf0c";